const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
const {Button, Input} = require('ui-library');
const i18n = require('i18n');

const MIN_LENTH_FOR_PHONE_NUMBER = 8;
const MAX_LENGTH_FOR_PHONE_NUMBER = 10;

const VERIFICATION_CODE_LENGTH = 6;

const DIGIT_REGEX = /^[0-9]*$/;

module.exports = createClass({
  propTypes: {
    prefix: PropTypes.string,
    number: PropTypes.string,
    display: PropTypes.oneOf(['phone', 'code']),
    isVerified: PropTypes.bool,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    onChangeNumber: PropTypes.func,
    onChangeCode: PropTypes.func,
    onEditNumber: PropTypes.func,
    onSubmitPhone: PropTypes.func,
    onSubmitCode: PropTypes.func
  },

  hasJustDigits(text) {
    return DIGIT_REGEX.test(text)
  },

  onChangeNumber(event) {
    const number = event.target.value;

    if(!this.isValidPhone(number)) return event.preventDefault();

    const {onChangeNumber} = this.props;
    onChangeNumber && onChangeNumber(number);
  },

  isValidPhone(phone) {
    return this.hasJustDigits(phone) && phone.length <= MAX_LENGTH_FOR_PHONE_NUMBER;
  },

  onChangeCode(event) {
    const code = event.target.value;

    if(!this.isValidVerificationCode(code)) return event.preventDefault();

    const {onChangeCode} = this.props;
    onChangeCode && onChangeCode(code);
  },

  isValidVerificationCode(code) {
    return this.hasJustDigits(code) && code.length <= VERIFICATION_CODE_LENGTH;
  },

  submitPhone(event) {
    const {onSubmitPhone} = this.props;
    onSubmitPhone && onSubmitPhone();
  },

  submitCode(event) {
    const {onSubmitCode} = this.props;
    onSubmitCode && onSubmitCode();
  },

  getDefaultProps() {
    return { prefix: '', number: '', code: '' };
  },

  getPhone(prefix, number) {
    return `+${prefix}-${number}`;
  },

  isPhoneLengthValid() {
    const {number} = this.props;
    return number.length >= MIN_LENTH_FOR_PHONE_NUMBER &&
           number.length <= MAX_LENGTH_FOR_PHONE_NUMBER;
  },

  renderInputPhoneView() {
    const {number, prefix, error, disabled, isVerified} = this.props;
    const description = i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_INPUT_DESCRIPTION');
    const prefixStr = prefix ? `+${prefix}` : '...';
    const isPhoneLengthValid = this.isPhoneLengthValid();

    const getCodeBtn = (
      <Button
        size='sm'
        color='primary'
        className='get-code'
        onClick={this.submitPhone}
        disabled={!isPhoneLengthValid}
      >
        {i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_GET_CODE')}
      </Button>
    );
    const verifiedStr = (
      <div className='vf-text-primary' style={{marginLeft: '8.5rem'}}>
        <i className='icon-checkmark vf-primary-text margin-right-Hx' />
        {i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_VERIFIED')}
      </div>
    );

    return (
      <div>
        <div className='vf-row phone-number'>
          <div className='col-xs-12 vf-descriptor'>
            {description}
          </div>
        </div>
        <div className='vf-row padding-top-Hx'>
          <div className='col-xs-12 flex'>
            <div className='prefix-input flex'>{prefixStr}</div>
            <Input
              id='cellphone-input'
              className={error ? 'error' : ''}
              onChange={this.onChangeNumber}
              placeholder={i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_INPUT_PLACEHOLDER')}
              disabled={disabled}
              value={number}
            />
          </div>
        </div>
        <div className='vf-row padding-top-Hx'>
          <div className='col-xs-12'>
            {isVerified ? verifiedStr : getCodeBtn}
          </div>
        </div>
      </div>
    );
  },

  isCodeLengthValid() {
    const {code} = this.props;
    return code.length === VERIFICATION_CODE_LENGTH;
  },

  renderInputCodeView() {
    const {code, prefix, number, disabled, error, onEditNumber} = this.props;
    const description = (
      <div>
        <div>
          {i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_TYPE_VERIFICATION_CODE_WAIT')}
          <a onClick={this.submitPhone}>
            {i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_REQUEST_NEW_CODE')}
          </a>
        </div>
        <div className='margin-top-1x'>
          <span className='margin-right-Hx'>
            {i18n.get(
              'ADV_SETTINGS_ACCOUNT_PHONE_YOUR_PHONE',
              {phone: this.getPhone(prefix, number)}
            )}
          </span>
          <a onClick={onEditNumber}>
            {i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_EDIT')}
          </a>
        </div>
      </div>
    );
    const sendCodeBtn = (
      <Button
        size='sm'
        color='primary'
        id='send-verification-code-button'
        onClick={this.submitCode}
        disabled={!this.isCodeLengthValid()}
      >
        {i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_SEND_CODE')}
      </Button>);

    return (
      <div>
        <div className='vf-row'>
          <div className='col-xs-12 vf-descriptor'>
            {description}
          </div>
        </div>
        <div className='vf-row padding-top-Hx'>
          <div className='col-xs-12 flex'>
            <Input
              id='verification_code'
              className={error ? 'error' : ''}
              onChange={this.onChangeCode}
              placeholder={
                i18n.get('ADV_SETTINGS_ACCOUNT_PHONE_TYPE_VERIFICATION_CODE')
              }
              disabled={disabled}
              value={code}
            />
          </div>
        </div>
        <div className='vf-row padding-top-Hx'>
          <div className='col-xs-12'>
            {sendCodeBtn}
          </div>
        </div>
      </div>
    );
  },

  renderContent() {
    const {display} = this.props;
    if (display === 'code') return this.renderInputCodeView();
    return this.renderInputPhoneView();
  },

  render() {
    return (
      <div className='vf-cell-phone-verification'>
        {this.renderContent()}
      </div>
    );
  }
});
